import React from "react";

function getStatusLabel(record) {
  return (
    record?.statusName ??
    record?.status_name ??
    record?.statusLabel ??
    record?.status_label ??
    record?.status?.label ??
    record?.status ??
    "N/A"
  );
}

export default function SettlementPdfMedicalTable({ formatCurrency, records }) {
  return (
    <table className="settlement-pdf-table settlement-pdf-medical-table">
      <thead>
        <tr>
          <th>Medical</th>
          <th>Initial Bill</th>
          <th>Reduced To</th>
          <th>Discount</th>
          <th>Network Status</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {records.length ? (
          records.map((record, index) => {
            const isInNetwork = record?.providerInNetwork ?? record?.provider_in_network;

            return (
              <tr key={record?.pk ?? record?.id ?? `${record?.providerName}-${index}`}>
                <td>{record?.providerName ?? record?.provider_name ?? "N/A"}</td>
                <td className="text-center">{formatCurrency(record?.initialAmount ?? record?.initial_amount)}</td>
                <td className="text-center">{formatCurrency(record?.settledAmount ?? record?.settled_amount)}</td>
                <td className="text-center">{`${Math.round(record?.discount || 0)}%`}</td>
                <td className={`text-center ${isInNetwork ? "success-text" : "failure-text"}`}>
                  {isInNetwork ? "In Network" : "Out of Network"}
                </td>
                <td className="text-center">{getStatusLabel(record)}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td className="text-center" colSpan={6}>
              Nothing to show
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
